(() => {
  const MOBILE_BREAKPOINT = 999;

  function cleanText(text) {
    return (text || '').replace(/\s+/g, ' ').trim();
  }

  function toggleBodyOffset() {
    const hasVisibleSticky = document.querySelector('.product-form__sticky-mobile-atc.is-visible');
    document.documentElement.classList.toggle('has-sticky-mobile-atc', !!hasVisibleSticky);
  }

  function initStickyBuyButtons(root = document) {
    const wrappers = root.querySelectorAll('[data-sticky-atc-wrapper]');

    wrappers.forEach((wrapper) => {
      if (wrapper.dataset.stickyInit === 'true') return;

      const stickyButton = wrapper.querySelector('[data-sticky-atc-button]');
      const stickyLabel = wrapper.querySelector('[data-sticky-atc-label]');
      const formId = wrapper.dataset.productFormId;

      if (!stickyButton || !stickyLabel || !formId) return;

      let mainButton = null;
      let visibilityObserver = null;
      let mainButtonObserver = null;
      let formObserver = null;

      function getForm() {
        return document.getElementById(formId);
      }

      function getMainButton() {
        const form = getForm();
        return form ? form.querySelector('.product-form__add-button') : null;
      }

      function syncStickyState() {
        if (!mainButton) return;

        stickyButton.disabled = mainButton.disabled;
        stickyButton.classList.toggle('button--disabled', mainButton.disabled);
        stickyButton.classList.toggle('button--primary', !mainButton.disabled);

        const label = cleanText(mainButton.textContent);
        if (label) {
          stickyLabel.textContent = label;
        }
      }

      function bindVisibilityObserver() {
        if (visibilityObserver) {
          visibilityObserver.disconnect();
          visibilityObserver = null;
        }

        if (!mainButton) return;

        visibilityObserver = new IntersectionObserver(
          ([entry]) => {
            const showSticky = window.innerWidth <= MOBILE_BREAKPOINT && !entry.isIntersecting;
            wrapper.classList.toggle('is-visible', showSticky);
            toggleBodyOffset();
          },
          {
            root: null,
            threshold: 0.15
          }
        );

        visibilityObserver.observe(mainButton);
      }

      function bindMainButtonObserver() {
        if (mainButtonObserver) {
          mainButtonObserver.disconnect();
          mainButtonObserver = null;
        }

        if (!mainButton) return;

        mainButtonObserver = new MutationObserver(() => {
          syncStickyState();
        });

        mainButtonObserver.observe(mainButton, {
          attributes: true,
          childList: true,
          subtree: true,
          characterData: true
        });
      }

      function bindMainButton() {
        const nextMainButton = getMainButton();

        if (!nextMainButton) {
          mainButton = null;
          wrapper.classList.remove('is-visible');
          toggleBodyOffset();
          return;
        }

        if (mainButton === nextMainButton) {
          syncStickyState();
          return;
        }

        mainButton = nextMainButton;
        syncStickyState();
        bindVisibilityObserver();
        bindMainButtonObserver();
      }

      const form = getForm();

      if (form) {
        formObserver = new MutationObserver(() => {
          bindMainButton();
        });

        formObserver.observe(form, {
          childList: true,
          subtree: true
        });
      }

      stickyButton.addEventListener('click', (event) => {
        event.preventDefault();

        if (!mainButton || mainButton.disabled) return;

        mainButton.click();
      });

      window.addEventListener(
        'resize',
        () => {
          if (window.innerWidth > MOBILE_BREAKPOINT) {
            wrapper.classList.remove('is-visible');
            toggleBodyOffset();
          }

          bindMainButton();
        },
        { passive: true }
      );

      bindMainButton();
      wrapper.dataset.stickyInit = 'true';
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initStickyBuyButtons(document));
  } else {
    initStickyBuyButtons(document);
  }

  document.addEventListener('shopify:section:load', () => initStickyBuyButtons(document));
})();